var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{staticClass:"breadcrumb-inner",attrs:{"separator":"/"}},_vm._l((_vm.$route.matched),function(item){return _c('el-breadcrumb-item',{key:item.path},[_vm._v("\n        "+_vm._s(_vm.$t(item.name) || 'Home')+"\n    ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }